import { render } from "./TermsText.vue?vue&type=template&id=61fd4780"
import script from "./TermsText.vue?vue&type=script&lang=js"
export * from "./TermsText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__